import IconTile from "@/components/common/iconTile/iconTile.component";
import RingBulletItem from "@/components/common/ringBulletItem/ringBulletItem.component";
import type { LucideIcon } from "lucide-react";

export interface TriggerCard {
  title: string;
  icon: LucideIcon;
  items: string[];
  note: string;
}

interface TriggerCardsProps {
  cards: TriggerCard[];
  ariaLabel: string;
  caption?: string;
}

// Cards of example rewards grouped by what triggers them (visits, spend,
// time...) - the preview's `reward_triggers` visual.
const TriggerCards = ({ cards, ariaLabel, caption }: TriggerCardsProps) => (
  <figure role="group" aria-label={ariaLabel} className="m-0">
    <div className="grid gap-5 md:grid-cols-3">
      {cards.map((card, index) => (
        <article
          key={card.title}
          className="grid content-start gap-2 rounded-3xl border border-line bg-white p-6"
        >
          <IconTile icon={card.icon} index={index} size="lg" />
          <h3 className="mt-1 text-[1.2rem] leading-snug font-bold tracking-[-0.01em]">
            {card.title}
          </h3>
          <ul className="grid gap-2">
            {card.items.map((item) => (
              <RingBulletItem key={item} className="text-[15px] leading-snug">
                {item}
              </RingBulletItem>
            ))}
          </ul>
          <p className="mt-1 text-[14.5px] leading-relaxed text-ink-muted">
            {card.note}
          </p>
        </article>
      ))}
    </div>
    {caption && (
      <figcaption className="px-1 pt-3 text-[12.5px] text-ink-muted">
        {caption}
      </figcaption>
    )}
  </figure>
);

export default TriggerCards;
